import * as React from "react";
const SvgArrowDown = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12,17.42A1.48,1.48,0,0,1,10.93,17L2.3,8.35A1,1,0,0,1,3.78,6.88L12,15.1l8.22-8.22a1,1,0,0,1,1.47,1.47L13.06,17A1.46,1.46,0,0,1,12,17.42Z" }));
export default SvgArrowDown;
